import {Box, Checkbox, FormControlLabel, Typography} from '@mui/material';
import React, {useState} from 'react';
import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {
  assignCards,
  getAllCustomerCards,
  getBuildings,
  getCardsByElevator,
  getElevatorsByEntrance,
  getEntrancesByBuilding,
  removeCardsByElevator,
} from '../actions';
import CustomButton from './CustomButton';
import Select from './Select';

const OtherAccessTab = () => {
  const dispatch = useDispatch();
  const {id} = useParams();
  const [selectedCards, setSelectedCards] = useState([]);
  const {allCustomerCards, cardsLoading, cardsByElevator} = useSelector(
    s => s.cards,
  );
  // const {buildings} = useSelector(s => s.buildings);
  const { allBuildings } = useSelector(s => s.buildings);
  const {buildingEntrances, entrancesLoading} = useSelector(s => s.entrances);
  const {entranceElevators, elevatorsLoading} = useSelector(s => s.elevators);
  const [building, setBuilding] = useState('');
  const [entrance, setEntrance] = useState('');
  const [elevator, setElevator] = useState('');

  console.log("check here for buildings: ", allBuildings);

  const isCardSelected = cardId => {
    const foundIndex = selectedCards.findIndex(i => i === cardId);
    if (foundIndex > -1) {
      return true;
    } else {
      return false;
    }
  };

  const handleCardsSelect = e => {
    let selected = [...selectedCards];
    const isChecked = e.target.checked;
    const cardId = +e.target.dataset.id;
    if (isChecked) {
      selected.push(cardId);
    } else {
      selected = selected.filter(element => element !== cardId);
    }
    setSelectedCards([...selected]);
  };

  const onChangeBuilding = value => {
    setBuilding(value);
    setEntrance('');
    dispatch(getEntrancesByBuilding(value));
  };

  const onChangeEntrance = value => {
    setEntrance(value);
    dispatch(getElevatorsByEntrance(value));
  };

  const onChangeElevator = value => {
    setElevator(value);
    dispatch(getCardsByElevator(id, value));
  };

  const onSave = () => {
    dispatch(assignCards(selectedCards, elevator, id));
  };

  useEffect(() => {
    dispatch(getAllCustomerCards(id));
    dispatch(getBuildings());

    return () => {
      dispatch(removeCardsByElevator());
    };
  }, []);

  useEffect(() => {
    const selected = [];
    for (let i in cardsByElevator) {
      selected.push(cardsByElevator[i].cardId);
    }
    setSelectedCards(selected);
  }, [cardsByElevator]);

  return (
    <Box>
      <Typography fontWeight="bold" fontSize="18px">
        Cards
      </Typography>
      <Box display="flex" gap="2rem" mb="2rem" mt="1rem">
        <Select
          items={allBuildings}
          value={building}
          onChangeValue={onChangeBuilding}
          label="Building"
          width="30%"
        />
        <Select
          items={buildingEntrances}
          value={entrance}
          onChangeValue={onChangeEntrance}
          label="Entrance"
          disabled={!building || entrancesLoading}
          width="30%"
        />
        <Select
          items={entranceElevators}
          value={elevator}
          onChangeValue={onChangeElevator}
          label="Elevator"
          disabled={!entrance || elevatorsLoading}
          width="30%"
        />
      </Box>
      {allCustomerCards.map(item => (
        <FormControlLabel
          key={item.id}
          checked={isCardSelected(item.id)}
          onChange={handleCardsSelect}
          label={`${item.siteCode}  ${item.siteNumber}`}
          control={<Checkbox inputProps={{'data-id': item.id}} />}
        />
      ))}
      <Box mt="4rem">
        <CustomButton loading={cardsLoading} onClick={onSave}>
          Save
        </CustomButton>
      </Box>
    </Box>
  );
};

export default OtherAccessTab;
